<div class="p-relative flex justify-between">
    <h4 mat-dialog-title data-testid="create-person-title">Редактирование контакта</h4>
    <app-close-button [formGroup]="personForm" [dialogRef]='dialogRef'/>
</div>
<mat-dialog-content>
    <app-loader [isLoading]="loading()"/>
    <form class="flex-column" [formGroup]="personForm" (ngSubmit)="onSubmit()">
        <mat-form-field data-testid="role-select">
            <mat-label>Роль</mat-label>
            <mat-select formControlName="role" data-testid="select">
                @for (role of enumService.enumTranslateRoleToArrSelects(Role, authService.user().data.role); track role.value) {
                    <mat-option [value]="role.value">{{role.label}}</mat-option>
                }
            </mat-select>
            @if (personForm.controls.role.hasError('roleError')) {
                <mat-error>Недостаточно прав для выбора этой роли.</mat-error>
            }
        </mat-form-field>
        <mat-form-field appearance="fill">
            <mat-label>Имя</mat-label>
            <input matInput formControlName="firstName" data-testid="person-firstName-input"/>
        </mat-form-field>
        <mat-form-field appearance="fill">
            <mat-label>Фамилия</mat-label>
            <input matInput formControlName="lastName" data-testid="person-lastName-input"/>
        </mat-form-field>

        @if (personForm.controls['role'].value === Role.executor) {
            <app-group-selector [label]="'Группа'" [formCtrl]="personForm.controls.groupId"/>
        }

        @if (personForm.controls['role'].value !== Role.customer) {
            <mat-form-field appearance="fill">
                <mat-label>Логин</mat-label>
                <input matInput formControlName="login" data-testid="person-login-input"/>
            </mat-form-field>
            <mat-form-field appearance="fill">
                <mat-label>Пароль</mat-label>
                <input matInput formControlName="password" data-testid="person-password-input"/>
            </mat-form-field>
        }

        @if(personForm.controls['role'].value === Role.manager && authService.isAdmin()) {
            <app-group-selector [label]="'Доступные для управления группы'" [formCtrl]="personForm.controls.managesGroupsIds" [multiple]="true" [noneOption]="false"/>
        }

        <mat-form-field appearance="fill">
            <mat-label>Телефон</mat-label>
            <input matInput formControlName="phone" data-testid="person-phone-input"/>
        </mat-form-field>

        @if(personForm.controls['role'].value === Role.executor) {
            <button mat-flat-button (click)="openSchedule()" class="mrb-1" type="button" data-testid="schedule-button">Расписание</button>
        }

        <div class="flex justify-between">
            <button mat-stroked-button class="w-40" color="basic" type="button" [disabled]="!person.data.id" (click)="deletePerson(person.data.id)">Удалить</button>
            <button mat-flat-button class="w-40" color="primary" type="submit" [disabled]="!personForm.valid" data-testid="save-person-button">Сохранить</button>
        </div>
    </form>
</mat-dialog-content>
